import React from "react";
import { Tooltip, TooltipProps } from "@mui/material";

// Closer tooltips sat over the neighbouring buttons and swallowed the click meant for them.
// This one waits before opening, cannot be hovered into, and lets every click pass through it.
const CloserTooltip: React.FC<TooltipProps> = ({ slotProps, ...props }) => (
  <Tooltip
    enterDelay={700}
    enterNextDelay={700}
    disableInteractive
    {...props}
    slotProps={{ ...slotProps, popper: { ...slotProps?.popper, sx: { pointerEvents: "none" } } }}
  />
);

export default CloserTooltip;
